import { createFileRoute } from '@tanstack/react-router'
import SetNewPassword from '@/features/auth/set-new-password'

export const Route = createFileRoute('/(auth)/set-new-password')({
  component: SetNewPassword,
})
